/*
  Float Radio — Winamp Player JS v4
  Asset: float-radio-winamp.js
  Upload: Shopify > Themes > Edit Code > Assets
*/
(function () {

  /* ── Instagram lookup — update as new DJs added ── */
  var ARTIST_IG = {
    'float-radio-vol-1-dj-donuts':        'https://www.instagram.com/djdonuts617',
    'float-radio-vol-2-dj-frantic':       'https://www.instagram.com/dj_frantic',
    'float-radio-vol-3-dj-chris-paul':    'https://www.instagram.com/_chrispaul_101',
    'float-radio-vol-4-dj-ray-boston':    'https://www.instagram.com/djrayboston',
    'float-radio-vol-5-mike-said':        'https://www.instagram.com/mikesaid_dj',
    'float-radio-vol-6-jackmaster-flash': 'https://www.instagram.com/djjackmf'
  };

  /* ── State ── */
  var MIXES = window.FR_MIXES || [];
  var currentMix = -1;
  var playing = false;
  var elapsed = 0;
  var elapsedTimer = null;
  var MC_WIDGET = null;
  var shuffleOn = false;
  var repeatOn = false;

  /* ── Spectrum ── */
  var canvas = document.getElementById('wa-spectrum');
  var bars = [], peaks = [], peakHold = [];

  if (canvas) {
    var ctx = canvas.getContext('2d');
    function resizeCanvas() { canvas.width = canvas.offsetWidth; canvas.height = canvas.offsetHeight; }
    resizeCanvas();
    window.addEventListener('resize', resizeCanvas);
    var N = 52;
    bars = new Array(N).fill(0);
    peaks = new Array(N).fill(0);
    peakHold = new Array(N).fill(0);
    function drawSpectrum() {
      var W = canvas.width, H = canvas.height;
      ctx.clearRect(0, 0, W, H);
      var bw = Math.max(1, Math.floor(W / N) - 1);
      var grad = ctx.createLinearGradient(0, H, 0, 0);
      grad.addColorStop(0, '#001848');
      grad.addColorStop(0.55, '#0065F2');
      grad.addColorStop(1, '#70b8ff');
      for (var i = 0; i < N; i++) {
        if (playing) {
          var boost = Math.exp(-i * 0.028);
          var target = Math.random() * H * 0.92 * boost;
          bars[i] = bars[i] * 0.55 + target * 0.45;
          if (bars[i] >= peaks[i]) { peaks[i] = bars[i]; peakHold[i] = 22; }
          else { if (peakHold[i] > 0) peakHold[i]--; else peaks[i] = Math.max(0, peaks[i] - 0.9); }
        } else { bars[i] *= 0.86; peaks[i] = Math.max(0, peaks[i] - 0.6); }
        var x = i * (bw + 1);
        var h = Math.max(1, Math.round(bars[i]));
        ctx.fillStyle = grad;
        ctx.fillRect(x, H - h, bw, h);
        if (peaks[i] > 2) { ctx.fillStyle = '#fff'; ctx.fillRect(x, H - Math.round(peaks[i]) - 2, bw, 2); }
      }
      requestAnimationFrame(drawSpectrum);
    }
    drawSpectrum();
  }

  /* ── Helpers ── */
  function formatDur(secs) {
    var h = Math.floor(secs / 3600);
    var m = Math.floor((secs % 3600) / 60);
    var s = secs % 60;
    if (h > 0) return h + ':' + String(m).padStart(2,'0') + ':' + String(s).padStart(2,'0');
    return m + ':' + String(s).padStart(2,'0');
  }

  function slugFromFeed(feed) {
    return (feed || '').split('/').filter(Boolean).pop() || '';
  }

  function djFromSlug(slug) {
    // "float-radio-vol-1-dj-donuts" → "DJ Donuts"
    var after = slug.replace(/^float-radio-vol-\d+-/, '');
    return after.split('-').map(function(w){ return w.charAt(0).toUpperCase() + w.slice(1); }).join(' ');
  }

  /* ── Build playlist DOM ── */
  function buildPlaylist() {
    var list = document.querySelector('.wa-pl-list');
    if (!list) return;
    list.innerHTML = '';
    MIXES.forEach(function(mix, i) {
      var li = document.createElement('li');
      li.className = 'wa-pl-item';
      var igSlug   = mix.igKey || slugFromFeed(mix.feed);
      var igLookup = ARTIST_IG[igSlug] || '';
      var handle   = mix.handle || (igLookup ? '@' + igLookup.replace('https://www.instagram.com/', '').replace(/\/$/, '') : '@' + slugFromFeed(mix.feed).replace(/^float-radio-vol-\d+-/, '').replace(/-/g,''));
      li.innerHTML =
        '<span class="wa-pl-n">' + String(i+1).padStart(2,'0') + '.</span>' +
        '<img class="wa-pl-thumb" src="' + (mix.cover||'') + '" alt="" onerror="this.src=\'fr-wordmark.png\'">' +
        '<span class="wa-pl-info">' +
          '<span class="wa-pl-dj">Float Radio Vol. ' + mix.vol + ': ' + mix.dj + '</span>' +
          '<span class="wa-pl-handle">' + handle + '</span>' +
        '</span>' +
        '<span class="wa-pl-dur">' + formatDur(mix.durSecs) + '</span>';
      li.addEventListener('click', function(){ selectMix(i); });
      list.appendChild(li);
    });
    var countEl = document.getElementById('wa-pl-count');
    var footerEl = document.getElementById('wa-pl-footer-count');
    if (countEl) countEl.textContent = MIXES.length + ' Entries';
    if (footerEl) footerEl.textContent = MIXES.length + ' mixes · Float Radio';
  }

  /* ── Mixcloud API auto-load ── */
  function fetchMixcloud() {
    fetch('https://api.mixcloud.com/floathouse/cloudcasts/?limit=50')
      .then(function(r){ return r.json(); })
      .then(function(data){
        if (!data.data || !data.data.length) return;
        var cloudcasts = data.data.filter(function(c){
          return c.key && c.key.toLowerCase().indexOf('float-radio') !== -1;
        });
        cloudcasts.sort(function(a, b){
          var av = parseInt((a.key.match(/vol-(\d+)/) || [0,0])[1]);
          var bv = parseInt((b.key.match(/vol-(\d+)/) || [0,0])[1]);
          return av - bv;
        });
        if (!cloudcasts.length) return;
        MIXES = cloudcasts.map(function(c){
          var slug = slugFromFeed(c.key);
          var volMatch = c.key.match(/vol-(\d+)/);
          var vol = volMatch ? String(parseInt(volMatch[1])).padStart(2,'0') : '??';
          var dj = c.name || '';
          var ci = dj.indexOf(':');
          dj = ci !== -1 ? dj.substring(ci+1).trim() : djFromSlug(slug);
          return {
            vol: vol, dj: dj, vibe: '',
            cover: (c.pictures && (c.pictures.extra_large || c.pictures.large)) || '',
            feed: c.key, durSecs: c.audio_length || 0,
            mixcloudUrl: c.url, igKey: slug
          };
        });
        buildPlaylist();
      })
      .catch(function(){ /* API unavailable — hardcoded MIXES already loaded */ });
  }

  /* ── Time display ── */
  var timeEl = document.getElementById('wa-time');
  function updateTime() {
    if (!timeEl) return;
    var m = Math.floor(elapsed / 60), s = elapsed % 60;
    timeEl.textContent = m + ':' + String(s).padStart(2,'0');
  }

  /* ── Select mix ── */
  function selectMix(idx) {
    if (idx < 0 || idx >= MIXES.length) return;
    var mix = MIXES[idx];
    currentMix = idx;

    document.querySelectorAll('.wa-pl-item').forEach(function(el, i){
      el.classList.toggle('active', i === idx);
    });

    var cover = document.querySelector('.wa-cover-img');
    if (cover && mix.cover) { cover.src = mix.cover; cover.classList.add('visible'); }

    var titleEl = document.querySelector('.wa-track-title');
    var djEl    = document.querySelector('.wa-track-dj');
    if (titleEl) titleEl.textContent = 'Float Radio Vol.' + mix.vol;
    if (djEl)    djEl.textContent = mix.dj;

    var marquee = document.querySelector('.wa-marquee-txt');
    /* Set initial marquee text, then enrich with Mixcloud tags */
    var baseMarqueeText = 'Float Radio Vol.' + mix.vol + '  \u2014  ' + mix.dj + (mix.vibe ? '  \u2014  ' + mix.vibe : '') + '          ';
    if (marquee) marquee.textContent = baseMarqueeText;
    /* Async: fetch tags from Mixcloud API and append as hashtags */
    (function(feedPath, marqEl, baseText) {
      fetch('https://api.mixcloud.com' + feedPath + '?fields=tags')
        .then(function(r){ return r.json(); })
        .then(function(data){
          if (!marqEl || !data.tags || !data.tags.length) return;
          var tags = data.tags.slice(0,8).map(function(t){ return '#' + t.name.replace(/\s+/g,'-').toLowerCase(); }).join('  ');
          marqEl.textContent = baseText.trim() + '     ' + tags + '          ';
        })
        .catch(function(){});
    })(mix.feed, marquee, baseMarqueeText);
    /* Show marquee strip */
    var marqueeStrip = document.getElementById('fr-marquee-strip');
    if (marqueeStrip) marqueeStrip.classList.add('open');
    /* Artist panel */
    var slug  = mix.igKey || slugFromFeed(mix.feed);
    var mcUrl = mix.mixcloudUrl || ('https://www.mixcloud.com' + mix.feed);
    var igUrl = ARTIST_IG[slug] || '';
    var twUrl = mix.twitch ? ('https://www.twitch.tv/' + mix.twitch) : '';
    var artistDjEl  = document.getElementById('wa-artist-dj');
    var artistMcEl  = document.getElementById('wa-artist-mc');
    var artistIgEl  = document.getElementById('wa-artist-ig');
    var artistTwEl  = document.getElementById('wa-artist-tw');
    var artistMsgEl = document.getElementById('wa-artist-msg');
    if (artistDjEl)  artistDjEl.textContent = mix.dj;
    if (artistMcEl)  artistMcEl.href = mcUrl;
    if (artistIgEl)  { artistIgEl.href = igUrl; artistIgEl.style.display = igUrl ? '' : 'none'; }
    if (artistTwEl)  { artistTwEl.href = twUrl; artistTwEl.style.display = twUrl ? '' : 'none'; }
    if (artistMsgEl) artistMsgEl.textContent = mix.msg || '';
    var artistPanel = document.getElementById('wa-artist');
    if (artistPanel) artistPanel.classList.add('open');

    elapsed = 0;
    updateTime();
    loadMixcloudWidget(mix.feed, true);
    setPlaying(true);
    repositionWindows();
  }

  function setPlaying(val, fromWidget) {
    playing = val;
    var btn = document.getElementById('wa-play');
    if (btn) btn.classList.toggle('on', val);
    clearInterval(elapsedTimer);
    if (MC_WIDGET && !fromWidget) {
      if (val) MC_WIDGET.play(); else MC_WIDGET.pause();
    }
    /* Timer driven entirely by widget progress event — no fake interval */
  }

  /* ─────────── Mixcloud Widget Audio ─────────── */
  /* setupWidgetEvents: wire all widget event listeners */
  function setupWidgetEvents(w) {
    clearInterval(elapsedTimer);
    w.events.play.on(function() {
      playing = true;
      var b = document.getElementById('wa-play');
      if (b) b.classList.add('on');
    });
    w.events.pause.on(function() {
      playing = false;
      var b = document.getElementById('wa-play');
      if (b) b.classList.remove('on');
    });
    w.events.ended.on(function() {
      if (repeatOn) {
        selectMix(currentMix);
      } else if (shuffleOn) {
        var next = Math.floor(Math.random() * MIXES.length);
        if (MIXES.length > 1) while (next === currentMix) next = Math.floor(Math.random() * MIXES.length);
        selectMix(next);
      } else if (currentMix < MIXES.length - 1) {
        selectMix(currentMix + 1);
      } else {
        playing = false; var b = document.getElementById('wa-play'); if (b) b.classList.remove('on');
      }
    });
    w.events.progress.on(function(position, duration) {
      elapsed = Math.floor(position);
      updateTime();
      var posBar = document.querySelector('.wa-pos');
      if (posBar && duration > 0) {
        var pct = (position / duration) * 100;
        var pctClamped = Math.min(100, pct);
        posBar.value = pctClamped;
        posBar.style.setProperty('--val', pctClamped + '%');
        posBar.style.background = 'linear-gradient(to right, #0065F2 ' + pctClamped + '%, #2a2a2a ' + pctClamped + '%)';
      }
    });
  }

  /* createWidget: initialize iframe + widget for the first time */
  function createWidget(iframe, feed) {
    MC_WIDGET = null;
    iframe.src = 'https://www.mixcloud.com/widget/iframe/?feed=' +
                 encodeURIComponent(feed) +
                 '&mini=1&hide_cover=1&hide_artwork=1';
    iframe.onload = function() {
      if (!window.Mixcloud) return;
      try {
        var w = Mixcloud.PlayerWidget(iframe);
        MC_WIDGET = w;
        w.ready.then(function() { setupWidgetEvents(w); });
      } catch(e) { console.warn('MC widget init error', e); }
    };
  }

  /* loadMixcloudWidget: switch tracks without destroying the iframe.
     Uses widget.load() on subsequent calls — keeps the audio context
     alive on mobile so iOS gesture chain isn't broken. */
  function loadMixcloudWidget(feed, autoplay) {
    var iframe = document.getElementById('wa-mc-widget');
    if (!iframe) return;
    if (MC_WIDGET) {
      /* Widget exists — switch track in-place (no iframe reload) */
      try {
        MC_WIDGET.load(feed, !!autoplay);
        return;
      } catch(e) {
        console.warn('widget.load() failed, recreating', e);
      }
    }
    /* First time — create the widget */
    createWidget(iframe, feed);
    /* After init, autoplay is handled by widget.load(feed, true) on next call.
       For first selection, we trigger play once the widget is ready. */
    if (autoplay) {
      var attempts = 0;
      var waitAndPlay = setInterval(function() {
        attempts++;
        if (MC_WIDGET) {
          clearInterval(waitAndPlay);
          try { MC_WIDGET.play(); } catch(e) {}
        } else if (attempts > 20) {
          clearInterval(waitAndPlay);
        }
      }, 300);
    }
  }

  /* Pre-init the widget with MIXES[0] on page load so the audio context
     is ready before the user's first tap — helps mobile audio unlock. */
  (function preInit() {
    if (!MIXES.length) return;
    var iframe = document.getElementById('wa-mc-widget');
    if (!iframe) return;
    createWidget(iframe, MIXES[0].feed);
  })();
  /* ─────────────────────────────────────────────── */

  function repositionWindows() {
    var eqEl     = document.getElementById('wa-eq');
    var artistEl = document.getElementById('wa-artist');
    var plEl     = document.getElementById('wa-pl');
    var offset   = 284;
    if (eqEl     && eqEl.classList.contains('open'))     { eqEl.style.top     = offset + 'px'; offset += eqEl.offsetHeight; }
    if (artistEl && artistEl.classList.contains('open')) { artistEl.style.top = offset + 'px'; offset += artistEl.offsetHeight; }
    if (plEl     && plEl.classList.contains('open'))     { plEl.style.top     = offset + 'px'; offset += plEl.offsetHeight || 0; }
    var winampEl = document.getElementById('winamp');
    if (winampEl) winampEl.style.minHeight = (offset + 8) + 'px';
  }

  /* ── Controls ── */
  document.getElementById('wa-play')?.addEventListener('click', function(){
    if (currentMix < 0 && MIXES.length > 0) selectMix(0); else setPlaying(!playing);
  });
  document.getElementById('wa-pause')?.addEventListener('click', function(){ setPlaying(false); });
  document.getElementById('wa-stop')?.addEventListener('click', function(){
    setPlaying(false); elapsed = 0; updateTime();
    document.getElementById('wa-artist')?.classList.remove('open');
    document.getElementById('fr-marquee-strip')?.classList.remove('open');
    document.querySelector('.wa-cover-img')?.classList.remove('visible');
    repositionWindows();
  });
  document.getElementById('wa-prev')?.addEventListener('click', function(){ if (currentMix > 0) selectMix(currentMix - 1); });
  document.getElementById('wa-next')?.addEventListener('click', function(){
    if (shuffleOn && MIXES.length > 1) {
      var next = Math.floor(Math.random() * MIXES.length);
      while (next === currentMix) next = Math.floor(Math.random() * MIXES.length);
      selectMix(next);
    } else { selectMix(currentMix < MIXES.length - 1 ? currentMix + 1 : currentMix); }
  });

  document.getElementById('wa-eq-btn')?.addEventListener('click', function(){
    var win = document.getElementById('wa-eq');
    this.classList.toggle('on', win?.classList.toggle('open'));
    repositionWindows();
  });
  document.getElementById('wa-pl-btn')?.addEventListener('click', function(){
    var win = document.getElementById('wa-pl');
    this.classList.toggle('on', win?.classList.toggle('open'));
    repositionWindows();
  });

  document.querySelector('.wa-vol')?.addEventListener('input', function(){
    this.style.setProperty('--val', this.value + '%');
    if (MC_WIDGET) try { MC_WIDGET.setVolume(this.value / 100); } catch(e){}
  });
  document.querySelector('.wa-bal')?.addEventListener('input', function(){ this.style.setProperty('--val', this.value + '%'); });
  document.querySelector('.wa-pos')?.addEventListener('input', function(){
    this.style.setProperty('--val', this.value + '%');
    if (currentMix >= 0 && MIXES[currentMix] && MIXES[currentMix].durSecs) {
      var seekPos = (this.value / 100) * MIXES[currentMix].durSecs;
      elapsed = Math.round(seekPos);
      updateTime();
      if (MC_WIDGET) MC_WIDGET.seek(seekPos);
    }
  });

  document.getElementById('wa-shuf')?.addEventListener('click', function(){ this.classList.toggle('on'); shuffleOn = this.classList.contains('on'); });
  document.getElementById('wa-rep')?.addEventListener('click',  function(){ this.classList.toggle('on'); repeatOn = this.classList.contains('on'); });
  /* ── Keyboard shortcuts ── */
  document.addEventListener('keydown', function(e) {
    var tag = document.activeElement ? document.activeElement.tagName : '';
    if (tag === 'INPUT' || tag === 'TEXTAREA' || tag === 'SELECT') return;
    switch (e.code) {
      case 'Space':
        e.preventDefault();
        if (currentMix < 0 && MIXES.length > 0) selectMix(0); else setPlaying(!playing);
        break;
      case 'ArrowLeft':
        if (currentMix > 0) { e.preventDefault(); selectMix(currentMix - 1); }
        break;
      case 'ArrowRight':
        if (currentMix < MIXES.length - 1) { e.preventDefault(); selectMix(currentMix + 1); }
        break;
      case 'KeyM':
        var vol = document.getElementById('wa-vol');
        if (vol) { vol.value = vol.value > 0 ? 0 : 80; vol.dispatchEvent(new Event('input')); }
        break;
    }
  });
  /* ── Share button ── */
  document.getElementById('wa-share')?.addEventListener('click', function(){
    var btn = this;
    var mix = (currentMix >= 0 && MIXES[currentMix]) ? MIXES[currentMix] : null;
    var title = mix ? ('Float Radio Vol.' + mix.vol + ' — ' + mix.dj) : 'Float Radio';
    var text  = mix ? (mix.vibe + ' — Float Radio by Float House') : 'Float Radio by Float House';
    var url   = window.location.origin + '/pages/float-radio';
    function flashBtn(label) {
      var prev = btn.textContent;
      btn.textContent = label;
      btn.disabled = true;
      setTimeout(function(){ btn.textContent = prev; btn.disabled = false; }, 1800);
    }
    if (navigator.share) {
      navigator.share({ title: title, text: text, url: url }).catch(function(){});
    } else {
      try {
        navigator.clipboard.writeText(url).then(function(){
          flashBtn('✓');
        }).catch(function(){
          prompt('Copy link:', url);
        });
      } catch(e) {
        prompt('Copy link:', url);
      }
    }
  });

  /* ── Drag ── */
  var winampEl = document.getElementById('winamp');
  var titlebar = document.querySelector('.wa-titlebar');
  if (winampEl && titlebar) {
    var initPos = false;
    function initDrag() {
      if (!initPos) {
        var rect = winampEl.getBoundingClientRect();
        var sr   = winampEl.parentElement.getBoundingClientRect();
        winampEl.style.left = (rect.left - sr.left) + 'px';
        winampEl.style.top  = (rect.top  - sr.top)  + 'px';
        winampEl.classList.add('dragging');
        initPos = true;
      }
    }
    titlebar.addEventListener('mousedown', function(e){
      if (e.button !== 0) return;
      initDrag();
      var sx = e.clientX, sy = e.clientY;
      var ox = parseInt(winampEl.style.left)||0, oy = parseInt(winampEl.style.top)||0;
      function onMove(e){ winampEl.style.left = (ox+e.clientX-sx)+'px'; winampEl.style.top = (oy+e.clientY-sy)+'px'; }
      function onUp(){ document.removeEventListener('mousemove', onMove); document.removeEventListener('mouseup', onUp); }
      document.addEventListener('mousemove', onMove);
      document.addEventListener('mouseup', onUp);
      e.preventDefault();
    });
  }

  /* ── Init ── */
  buildPlaylist();      // render hardcoded fallback immediately
  fetchMixcloud();      // then try to refresh from Mixcloud API

})();
